// Must match the backend's PROPERTY_RECORD_NORMALIZATION_VERSION and
// COMP_SEARCH_SCHEMA_VERSION (functions/index.js) - bump them together. A
// cached subject lookup or comp search from any other version is treated as
// absent and re-fetched, so values produced by older normalization or
// retrieval logic (e.g. an acre lot size read as square feet) never reach a
// comparison.
export const SUBJECT_LOOKUP_NORMALIZATION_VERSION = 3;
export const COMP_SEARCH_SCHEMA_VERSION = 3;

export function isCurrentSubjectLookupCache(lookup) {
  return !!lookup && lookup.normalizationVersion === SUBJECT_LOOKUP_NORMALIZATION_VERSION;
}

export function isCurrentCompSearchCache(pricingComps) {
  return !!pricingComps && pricingComps.searchSummary?.schemaVersion === COMP_SEARCH_SCHEMA_VERSION;
}
